// extracted by mini-css-extract-plugin
module.exports = {"GetToKnowItems":"GetToKnowItems_GetToKnowItems__3b0kG"};